module.exports = __webpack_public_path__ + "img/board-bg.f394e859.svg";